var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 144,
    viewBox: "0 0 332 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.486 101.707C145.486 101.668 145.488 101.639 145.493 101.601C146.382 95.3437 149.492 42.3419 192.448 38.4849C219.732 37.3267 250.014 60.0722 281.07 60.0722C298.165 60.0722 313.802 53.1431 326.191 40.0006C326.442 39.7338 326.895 39.9092 326.895 40.2759V84.1792C326.895 84.9933 326.585 85.7796 326.017 86.3621C313.281 99.4027 297.331 106.277 279.934 106.277C248.878 106.277 222.367 84.6893 191.312 84.6893C174.543 84.6893 159.178 91.3562 146.905 104.014C146.394 104.541 145.486 104.185 145.486 103.452V101.707Z",
    fill: "url(#paint0_linear_1871_4495)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37495 43.6573V28.9868H78.5328V43.6573H52.268V114.643H34.6398V43.6573H8.37495ZM84.8411 114.643H65.6749L95.3707 28.9868H118.205L147.782 114.643H128.734L122.286 94.8855H91.289L84.8411 114.643ZM95.7848 81.0432H117.79L107.083 48.2714H106.492L95.7848 81.0432ZM151.076 28.9868L171.898 94.294H172.727L193.667 28.9868H213.307L183.729 114.643H160.896L131.2 28.9868H151.076ZM220.585 114.643V28.9868H278.084V43.6573H238.332V64.4798H275.126V79.1503H238.332V99.9729H278.202V114.643H220.585Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1871_4495",
    x1: 318.663,
    y1: 30.794,
    x2: 120.673,
    y2: 126.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324999,
    stopColor: "#1A5BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#233D81"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTave);
export default __webpack_public_path__ + "static/media/LogoTave.5c069502b7aa7f9922c05c35594270f2.svg";
export { ForwardRef as ReactComponent };